import { render, staticRenderFns } from "./BookContent.vue?vue&type=template&id=f2bce950&"
import script from "./BookContent.vue?vue&type=script&lang=js&"
export * from "./BookContent.vue?vue&type=script&lang=js&"
import style0 from "./BookContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2bce950')) {
      api.createRecord('f2bce950', component.options)
    } else {
      api.reload('f2bce950', component.options)
    }
    module.hot.accept("./BookContent.vue?vue&type=template&id=f2bce950&", function () {
      api.rerender('f2bce950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/運勢書2024/BookContent.vue"
export default component.exports